import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getActiveDocumentId, getTaskResultLimit, getTaskResultLimitInProgress } from "../redux/selectors";
import TaskResultLimitPanel from "./taskResultLimitPanel";
const mapStateToProps = (state) => ({
    documentId: getActiveDocumentId(state),
    taskResultLimit: getTaskResultLimit(state),
    inProgress: getTaskResultLimitInProgress(state)
});
const mapDispatchToProps = (dispatch) => ({
    onGetTaskResultLimit: (documentId) => dispatch(actionCreators.getTaskResultLimit(documentId)),
    onSaveTaskResultLimit: (documentId, taskResult) => dispatch(actionCreators.saveTaskResultLimit(documentId, taskResult))
});
export default connect(mapStateToProps, mapDispatchToProps)(TaskResultLimitPanel);
